/**
 * Scroll to product detail
 */
$('[data-tabs]').on('change.zf.tabs', function($target, $targetContent) {
	$('body,html').animate({
		scrollTop: $(".prod-detail").offset().top
	}, 400);
});

/**
 * Product images detail popup
 */
$(".prod-detail .tabs-panel").lightGallery({
	selector: '.lightbox',
	download: false
});

/**
 * Product images swiper
 */
var galleryMain = new Swiper('.prod-detail-images', {
	autoHeight: true,
	slidesPerView: 1, 
	onSlideChangeEnd: function(swiper) {  
		var activeIndex = swiper.activeIndex; 
		$(galleryThumbs.slides).removeClass('swiper-slide-active').removeClass('is-selected'); 		
		$(galleryThumbs.slides).eq(activeIndex).addClass('swiper-slide-active').addClass('is-selected'); 		
	},
	onInit: function() {
		// console.log('swiper main');
	}
});

/*var galleryThumbs = new Swiper('.prod-detail-thumbs', {
	autoHeight: true,
  spaceBetween: 10, 
  slidesPerView: 3, 
  slideToClickedSlide: true,
  centeredSlides: false, 
  onClick: function (swiper, event){
    var clicked = swiper.clickedIndex;
    swiper.activeIndex = clicked;  
    galleryThumbs.activeIndex = clicked;
    galleryMain.slideTo(clicked, 500);
  },
  onInit: function() {
  	console.log('swiper thumbs');
  }
});
// galleryMain.params.control = galleryThumbs;
galleryThumbs.params.control = galleryMain;
*/



/*$(window).scroll(function () {
	if ($(this).scrollTop() > 400) $('.scroll-to-top').fadeIn();
	else $('.scroll-to-top').fadeOut(); 
});

$('.off-canvas-content').on('click', '.scroll-to-top', function () {
	$('body,html').animate({ scrollTop: 0 }, 400);
	return false;
});*/
